import React, { Component } from 'react';
import withStyles from '@mui/styles/withStyles';
import { Button as TabButton } from '@mui/material';
import Modal from '@mui/material/Modal';
import Clear from '@mui/icons-material/Clear';
import { stringIsNullOrEmpty } from '../../../util/strings';
import Typography from '../../../component/Typography';
import { isNullOrUndefined } from '../../../util/objects';
import IconButton from '@mui/material/IconButton';
import Inline, { inlineAlignment } from './Inline';
import TaskStar from '../TaskStar';
import Hidden from '../../../component/Hidden';
import Grid from '../../../component/form/Grid';

class ModalWrapper extends Component {
    state = {
        index: 0
    };

    static getDerivedStateFromProps(newProps, oldState) {
        if (!isNullOrUndefined(newProps.activeTab) && oldState.activeTab !== newProps.activeTab) {
            return { index: newProps.activeTab };
        }
        return null;
    }

    render() {
        const { variant = 'primary' } = this.props;

        if (variant === 'simple') return this.renderSimple();

        if (stringIsNullOrEmpty(variant) || variant === 'primary') return this.renderPrimary();

        if (variant === 'task') return this.renderTask();

        if (variant === 'stepped') return this.renderStepped();

        return <span>unknown modal variant {variant}</span>;
    }

    renderSimple() {
        const { open, onClose, className, canClickOut = true, BackdropProps, children } = this.props;
        return (
            <Modal // `disableBackdropClick` is removed by codemod.
                // You can find more details about this breaking change in [the migration guide](https://mui.com/material-ui/migration/v5-component-changes/#modal)

                aria-labelledby="modal-title"
                aria-describedby="modal-description"
                open={open}
                disableEscapeKeyDown={!canClickOut}
                BackdropProps={BackdropProps}
                onClose={onClose}
            >
                <div className={`modal ${className || ''}`}>
                    <div className="paper">
                        <IconButton
                            color="primary"
                            aria-label="Close"
                            className="fab close"
                            onClick={() => onClose()}
                            size="large"
                        >
                            <Clear />
                        </IconButton>
                        {children}
                    </div>
                </div>
            </Modal>
        );
    }

    renderStepped() {
        const { open, onClose, steps = [], canClickOut = false, children, className } = this.props;
        const { index } = this.state;

        return (
            <Modal
                open={open}
                onClose={onClose}
                aria-labelledby="stepped-modal-title"
                aria-describedby="stepped-modal-description"
                disableEscapeKeyDown={!canClickOut}
                className={className}
            >
                <div className="modal modal--stepped">
                    <div className="modal-header">
                        {steps.map((step, i) => (
                            <div key={i}>
                                <TabButton
                                    className={`step-title-button ${index === i ? 'active' : ''}`}
                                    onClick={() => this.handleTabClick(step, i)}
                                >
                                    {step.abbreviation}
                                </TabButton>
                            </div>
                        ))}
                    </div>
                    <div className="modal-content paper">
                        {this.renderStep(index, steps[index])}
                        {children}
                    </div>
                </div>
            </Modal>
        );
    }

    handleTabClick(step, index) {
        this.setState({ index: index });
        if (step.hasOwnProperty('onChangeTab')) {
            step.onChangeTab(index);
        }
    }

    renderPrimary() {
        const { open, title, subtitle, onClose, children, canClickOut = false } = this.props;

        return (
            <Modal
                open={open}
                onClose={onClose}
                aria-labelledby="primary-modal-title"
                aria-describedby="primary-modal-description"
                disableEscapeKeyDown={!canClickOut}
            >
                <div className="modal modal--primary">
                    <div className="modal-header">
                        <Typography className="header" size="xs">
                            {title}
                        </Typography>
                        {subtitle && (
                            <Typography className="subtitle" size="xxlg">
                                {subtitle}
                            </Typography>
                        )}
                    </div>
                    <div className="modal-content paper">{children}</div>
                </div>
            </Modal>
        );
    }

    renderTask() {
        const { open, title, taskid, onClose, children, canClickOut = true } = this.props;

        return (
            <Modal
                className="workqueue-page"
                open={!!open}
                onClose={onClose}
                aria-labelledby="primary-modal-title"
                aria-describedby="primary-modal-description"
                disableEscapeKeyDown={!canClickOut}
            >
                <div className="modal modal--task">
                    <div className="modal-header">
                        <div className="title-container">
                            <Hidden smDown>
                                <Inline center>
                                    <Typography className="header" size="xs">
                                        {taskid && ` #${taskid}`}
                                    </Typography>
                                </Inline>
                                {title && (
                                    <Typography className="subtitle" size="xxlg">
                                        {title}
                                    </Typography>
                                )}
                            </Hidden>
                            <Hidden smUp>
                                {title} {taskid && ` #${taskid}`}
                            </Hidden>
                        </div>
                        <div className="star-container">
                            <TaskStar disabled />
                        </div>
                    </div>
                    <div className="modal-content paper">{children}</div>
                </div>
            </Modal>
        );
    }

    renderStep(index, step) {
        return (
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <div className="step-title">
                        <Inline alignment={inlineAlignment.rightAlignSiblings} center>
                            <Typography
                                variant="display1"
                                style={{ fontSize: '1.6rem', lineHeight: 1.20588, color: 'rgba(0, 0, 0, 0.54)' }}
                            >
                                {!!step.title && <span className="step-title-number">{step.title}&nbsp;</span>}
                                <span className="step-title-detail">{step.subtitle}</span>
                            </Typography>
                            <div className="step-button">{step.button}</div>
                        </Inline>
                    </div>
                </Grid>
                <Grid item xs={12}>
                    <div className="step-content">{step.content}</div>
                </Grid>
            </Grid>
        );
    }
}

export default withStyles({})(ModalWrapper);
